import { enhancedAxiosErrorTitle } from "api/enhanceAxiosErrorStack";

import { isAxiosError } from "./getErrorMessage";

export function getEnhancedAxiosErrorStack<T = unknown>(
  error: T,
): string | undefined {
  if (!isAxiosError(error)) return;

  const { response } = error;

  if (!response) return;

  if ("topMostError" in response.config) {
    const topMostError = response.config.topMostError as Error;
    const originalStack = error.stack;

    const { cleanedStack, axiosErrorLine } = extractAxiosErrorLine(
      originalStack ?? "",
    );

    const axiosErrorMessage = axiosErrorLine?.split(":")[1].replace("\n", "");

    const stackWithErrorMessage = topMostError.stack?.replace(
      enhancedAxiosErrorTitle,
      enhancedAxiosErrorTitle + " " + axiosErrorMessage,
    );

    const topMostErrorStack = stackWithErrorMessage + "\n" + cleanedStack;

    return topMostErrorStack;
  }
}

// Updated function that returns both the cleaned string and the matched line
export function extractAxiosErrorLine(stack: string): {
  cleanedStack: string;
  axiosErrorLine?: string;
} {
  const match = stack.match(/^AxiosError: .*(\r?\n)?/m);
  const axiosErrorLine = match ? match[0] : undefined;
  const cleanedStack = stack.replace(/^AxiosError: .*(\r?\n)?/m, "");

  return {
    cleanedStack,
    axiosErrorLine,
  };
}
